import React from 'react';

import { MenuReorderItemsListItem } from 'features/menu/components/menu-reorder-widget/menu-reorder-items-list/menu-reorder-items-list-item';
import { MappedOrder } from 'features/menu/components/menu-reorder-widget/types';
import { FlatList } from 'react-native';

export const MenuReorderItemsList = ({
  orderEntries,
  ListHeaderComponent,
}: {
  orderEntries: MappedOrder['orderEntries'];
  ListHeaderComponent: React.ComponentType<any>;
}) => (
  <FlatList
    data={orderEntries}
    renderItem={({ item }) => <MenuReorderItemsListItem item={item} />}
    keyExtractor={item => item.sanityId}
    ListHeaderComponent={ListHeaderComponent}
    stickyHeaderIndices={[0]}
    style={{ width: '100%' }}
  />
);
